import * as S from './styles'

interface Props {
  options: string[];
  onChange: (event: any) => void;
  value?: string;
  defaultValue?: string;
  'data-testid': string;
  containerStyle?: React.CSSProperties;
  style?: React.CSSProperties;
  disabled?: boolean;
}

const FieldDropdown = ({
  options, onChange, value, defaultValue, containerStyle, ...restProps
}: Props) => (
  <S.Wrapper style={containerStyle}>
    <S.Select
      onChange={onChange}
      value={value}
      defaultValue={defaultValue || ''}
      {...restProps}
    >
      <S.Option disabled hidden value=''>
        Selecione
      </S.Option>
      {options.map((option) => (
        <S.Option key={option} value={option}>
          {option}
        </S.Option>
      ))}
    </S.Select>
  </S.Wrapper>
)

export { FieldDropdown }
